<template>
    <el-tabs v-model="activeName" class="demo-tabs">
        <el-tab-pane v-if="isFlow" label="流程动态" name="first">
            <div class="well" v-for="(item,index) in FlowAudits"
                :key="item.EventId">
                <div class="Audits-Header">
                    <div class="Audits-User">
                           {{ FlowNodeMap[item.SourceNodeId] }}
                    </div> 
                    <div class="Audits-Operator"> 
                        {{ UserMap[item.UserName] }}{{ item.EventName }}于{{ dayDateTime(item.CreatedUtc) }}
                        <div class="Audits-User Audits-Location"><el-icon><locationInformation /></el-icon>{{ item.ClientIP }}</div>
                    </div> 
                    
                    <div class="Audits-Link" @click="detailView(item.EventId)">流程详情</div>
                </div>
                <div v-if="index != FlowAuditsLatest">
                    <div> 
                        开始处理 ：{{ dayDateTime(item.previousUtc) }}
                    </div>
                    <div>
                        处理耗时 ：{{ item.Diff }}
                    </div>
                </div>
                <div v-else>
                    <div> 
                        开始处理 ：{{ dayDateTime(item.CreatedUtc) }}
                    </div>
                </div>
            </div>
        </el-tab-pane>

        <el-tab-pane label="数据日志" name="second">
            <div class="well" v-for="item in Audits"
                :key="item.EventId">
                <div class="Audits-Header">
                    <div class="Audits-User">
                        <el-icon><userFilled /></el-icon>  {{ UserMap[item.UserName] }}
                    </div> 
                    <div class="Audits-Operator">  
                        {{ item.EventName }}于{{ dayDateTime(item.CreatedUtc) }}
                        <div class="Audits-User Audits-Location">
                            <el-icon><locationInformation /></el-icon>{{ item.ClientIP }}
                        </div>
                    </div> 
                    <div class="Audits-Link" @click="detailView(item.EventId)">数据详情</div>
                    <!-- <div class="Audits-Link" v-if="!isFlow" @click="detailRestore(item.EventId)">恢复</div> -->
                </div>
                <div v-if="item.EventName !== '创建'">数据有{{ item.ChangeFields.length }}处修改</div>
                <div v-for="field in item.ChangeFields" class="Audits-tag-group"> 
                    {{ FieldMap[field] }} :
                    <span v-if="!qweIsEmpty(item.Previous[field])" class="deleteSpan el-tag el-tag--danger">
                        {{ item.Previous[field] }}
                    </span>
                    <span class="el-tag el-tag--success"> 
                        {{ item.Current[field] }} 
                    </span>
                </div>
            </div>
        </el-tab-pane>
        
        <el-tab-pane v-if="isFlow" label="流程流转" name="third">Role</el-tab-pane>

        <el-tab-pane v-if="isAdmin" label="工作流执行" name="four">
            <div class="well" v-for="item in WorkflowAudits"
                :key="item.WorkflowId">
                <div class="Audits-Header">
                    <div class="Audits-User">
                        <el-tag :type="item.Success ? 'success': 'danger'"  effect="dark">{{ item.Success ? '成功': '失败' }}</el-tag>
                    </div> 
                    <div class="Audits-Operator">  
                        于{{ dayDateTime(item.CreatedUtc) }}
                    </div>
                    <div class="Audits-Link" @click="workflowDetailView(item.WorkflowId)" :data-view="'/api/workflowDetial/'+ item.WorkflowId">数据详情</div>
                </div>
                <div v-if="!item.Success" class="Audits-tag-group"> 
                    明细：{{item.FaultMessage}}
                </div>
            </div>
        </el-tab-pane>
    </el-tabs>
    <el-drawer size="80%" 
        class="qwe-grid-drawer"
        destroy-on-close
        v-model="visibleState">
        <template #header><h2>数据详情</h2></template>
        <qweForm isPropMode
                :propDatas="propDatas"
                :display="true"
                :is-show-head="false"></qweForm>
    </el-drawer>
</template>

<style>
    .demo-tabs{
        margin: 0 0.8em;
    }
    .well{
        background-color: #F5F5F5;
        border-radius: 4px;
        padding: 10px 15px;
        margin-bottom: 10px;
        margin-right: 10px;
    }

    .well>div{
        margin-bottom:6px ;
    }
     .well>div:last-child{
        margin-bottom:0px ;
    }

    .Audits-Header{
        display: flex;
        align-items: center;
    }
    .Audits-User{
        display: flex;
        font-weight: 600;
        color: #212529;
        align-items: center;
    }
    .Audits-Operator{
        flex: 1 0 auto;
        font-size: 13px;
        padding-left: 13px;
        display: flex;
    }
    .Audits-Location{
        padding-left: 5px;
    }
    .Audits-Link{
        color: #096dd9;
        cursor: pointer;
        margin-right: 10px;
    }
    .Audits-tag-group span {
        color: #1f2d3d !important;
    }
    .deleteSpan{
        text-decoration: line-through;
        background: #fdecec;
        margin-right: 8px;
    }
</style>

<script>
    import { UserFilled, LocationInformation,Flag } from '@element-plus/icons-vue';
    import { getContentAudits, getAuditDetail, getWorkflowAuditDetail } from '../../apis/httpHelper'
    import { dayDateTime, dayDiff, qweIsEmpty } from '../../common/commonHelper'
    import QweForm from "../Form/FormItem.vue"

    export default {
        name:"ContentAuditTrail",
        props:{
            contentItemId:{
                type : String
            }
        },  
        components:{
            "userFilled":UserFilled,
            'locationInformation':LocationInformation,
            'flag':Flag,
            'qweForm':QweForm
        },
        data:function(){
            return {
                activeName:"first",
                isFlow:true,
                Audits:[],
                FlowAudits:[],
                WorkflowAudits:[],

                UserMap:{},
                FlowNodeMap:{},
                FieldMap:{},
                FlowEdges:[],

                propDatas:[],
                visibleState:false
            }
        },

        computed:{
            FlowAuditsLatest : function(){
                return this.FlowAudits.length - 1;
            },

            isAdmin:function(){
                return this.$store.state.userInfo.IsSuperAdmin
            }
        },

        created:function(){
            getContentAudits(this.contentItemId)
                .then(x=>{  
                    this.isFlow = x.Result.IsFlow; 

                    (x.Result.Users || []).forEach(x=>{
                        this.UserMap[x.Value] = x.Text;
                    });    
                    (x.Result.Fields || []).forEach(x=>{
                        this.FieldMap[x.Value] = x.Text;
                    }); 

                    this.handlerAudits(x.Result.AuditTrail || []);
                    
                    if(this.isFlow){
                        (x.Result.FlowNodes || []).forEach(x=>{
                            this.FlowNodeMap[x.Value] = x.Text;
                        });  
                        this.handlerFlowAudits(x.Result.FlowAuditTrail || []);
                    }
                    else{
                        this.activeName = "second"
                    }
                }).catch(x=>{
                    console.log(x);
                });
            getWorkflowAuditDetail(this.contentItemId)
                .then(x=>{
                    this.WorkflowAudits = x.Result;
                });
        },
        methods:{
            detailView:function(id){
                getAuditDetail(id).then(x=>{
                    this.propDatas = x.Result;
                    this.visibleState = true;
                })
            },

            workflowDetailView:function(workflowId){
                window.open(this.$store.state.baseUrl + "/api/workflowDetial/"+workflowId,"_blank");
            },

            dayDateTime:function(date){
                return dayDateTime(date)
            },

            handlerFlowAudits:function(flowAudits){
                flowAudits.forEach((x,index)=>{
                    let currentUtc = x.CreatedUtc;
                    let previousUtc = flowAudits[index+1]?.CreatedUtc;
                    x.previousUtc = previousUtc;
                    x.Diff = dayDiff(currentUtc,previousUtc);
                });
                this.FlowAudits = flowAudits;
            },

            handlerAudits:function(audits){
                audits.forEach((x,index)=>{
                    let fields = x.ChangeFields;
                    let handlerResult = this.handlerContentItem(fields, x.Content, audits[index+1]?.Content);
                    x.Current = handlerResult.current;
                    x.Previous = handlerResult.previous;
                });
                this.Audits = audits;
            },

            handlerContentItem:function(fields, current, previous){
                let result = {current:{},previous:{}};
                fields.forEach(x=>{
                    let currentValue = current[x]?.Value;
                    let previousValue = previous == undefined ? undefined : previous[x]?.Value;
                    result.current[x] = currentValue;
                    result.previous[x] = previousValue;
                })
                return result;
            },
            
            qweIsEmpty:function(value){
                return qweIsEmpty(value)
            }
        }
    }
</script>